/**
 * apiFetch — drop-in wrapper around fetch() that:
 *   - Automatically handles 401 Unauthorized by clearing session and redirecting to /login.
 *   - Usage is identical to fetch(url, options).
 *
 * Import and use instead of fetch() for all VAS API calls:
 *   import { apiFetch } from "../../utils/apiFetch";
 *   const res = await apiFetch(url, { method: "GET", headers });
 */

const logout = () => {
  localStorage.removeItem("userVASData");
  localStorage.removeItem("companyName");
  localStorage.removeItem("companyData");
  localStorage.removeItem("companyVASData");
  // Redirect without React Router since this runs outside component context
  window.location.href = "/login";
};

export const apiFetch = async (url, options = {}) => {
  const response = await fetch(url, options);
  if (response.status === 401) {
    logout();
    // Return a never-resolving promise so calling code doesn't continue
    return new Promise(() => {});
  }
  return response;
};
